import { createApp } from 'vue'
import router from '../routes/index'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueLoading from 'vue-loading-overlay'
import Adjust from '@adjustcom/adjust-web-sdk'
import "./assets/reset.css"
import toast from '@/components/common/toast.js'
import App from '@/App.vue'
import './registerServiceWorker'
import "vant/lib/index.css"
import store from '../store/index'
import { DatePicker, Cell, Popup,Swipe, SwipeItem } from 'vant'
import { Locale } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import {register} from 'swiper/swiper-element'
register()
Locale.use('en-US', enUS);

Adjust.initSdk({
appToken: 'kjm6ivz1y2gw',
environment: 'production'
});  
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
let adjust_referrer = getParameterByName("adjust_referrer")
try {
    Adjust.setReferrer(encodeURIComponent(`${adjust_referrer}`)) 
    // console.log(adjust_referrer)  
} catch (error) {
    console.log(error)
}
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker1.js')
.then(function(registration) {
    console.log('Service Worker registered with scope:', registration.scope);
})
.catch(function(error) {
    console.error('Service Worker registration failed:', error);
});
}
let app = createApp(App)
app.config.globalProperties.$toast = toast
app.use(router).use(store).use(VueLoading).use(DatePicker).use(Cell).use(Popup).use(Swipe).use(SwipeItem)
app.provide('$toast', toast)
app.mount('#app')
store.dispatch("fetchConfig")